import React, { useState, useEffect } from 'react';
import SubscriptionTable from '../components/admin/SubscriptionTable';
import '../components/styles/AdminPage.css';
import AdminSidebar from "../components/admin/AdminSidebar";

const AdminPage = () => {
    const [id, setId] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [subscriptionMonths, setSubscriptionMonths] = useState('');
    const [secretToken, setSecretToken] = useState('');
    const [buyerName, setBuyerName] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoggedIn(true);
        if (isLoggedIn) {
            fetchSubscriptions();
            fetchProducts();
        }
    }, [isLoggedIn]);

    const fetchSubscriptions = async () => {
        try {
            const response = await fetch('/api/subscription/list/temp');
            if (response.ok) {
                const data = await response.json();
                setSubscriptions(data);
                setIsLoading(false);
            } else {
                setError('Failed to fetch subscription data');
            }
        } catch (error) {
            setError('An error occurred while fetching subscription data');
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await fetch('/api/items');
            if (response.ok) {
                const data = await response.json();
                if (data.items && Array.isArray(data.items)) {
                    const productList = data.items.map(item => ({
                        id: item.itemId,
                        name: item.itemName
                    }));
                    setProducts(productList);
                } else {
                    setError('Invalid product data structure');
                }
            } else {
                setError('Failed to fetch product data');
            }
        } catch (error) {
            setError('An error occurred while fetching product data');
        }
    };

    const handleCreateSubscription = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('/api/subscription/create-hash-key/temp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    id: selectedProduct,
                    days: parseInt(subscriptionMonths) * 30,
                    secret_token: secretToken,
                    buyerName: buyerName,
                }),
            });

            if (response.ok) {
                const hashKey = await response.text();
                alert(`해시키 생성이 완료되었습니다. ${hashKey}`);
                fetchSubscriptions(); // Refresh the subscription list
            } else {
                const errorMessage = await response.text();
                setError(`Failed to create subscription: ${errorMessage}`);
            }
        } catch (error) {
            setError('An error occurred while creating the subscription');
        }
    };

     return (
         <div className="admin-dashboard">
             <AdminSidebar /> {/* ⬅️ 사이드바 삽입 */}
            <div className="admin-content">
                <h1 className="title">구독 생성</h1>
                {/*<p>Welcome to the admin dashboard. You are now logged in.</p>*/}


                <div className="subscription-form">
                    <h2>새로운 구독 생성</h2>
                    <form onSubmit={handleCreateSubscription}>
                        <div className="form-group">
                            <label htmlFor="buyerName">구매자 이름:</label>
                            <input
                                type="text"
                                id="buyerName"
                                value={buyerName}
                                onChange={(e) => setBuyerName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="product">상품 선택:</label>
                            <select
                                id="product"
                                value={selectedProduct}
                                onChange={(e) => setSelectedProduct(e.target.value)}
                                required
                            >
                                <option value="">상품을 선택해주세요.</option>
                                {products.map((product) => (
                                    <option key={product.id} value={product.id}>
                                        {product.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="months">구독 개월 수:</label>
                            <select
                                id="months"
                                value={subscriptionMonths}
                                onChange={(e) => setSubscriptionMonths(e.target.value)}
                                required
                            >
                                <option value="">구독 개월 수를 선택해주세요.</option>
                                <option value="1">1 개월</option>
                                <option value="3">3 개월</option>
                                <option value="6">6 개월</option>
                                <option value="12">12 개월</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="secret_token">Secret Token:</label>
                            <input
                                type="password"
                                id="secret_token"
                                value={secretToken}
                                onChange={(e) => setSecretToken(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="create-button">구독 생성</button>
                    </form>
                </div>

                {!isLoading && (
                    <SubscriptionTable products={products} subscriptions={subscriptions} />
                )}

            </div>
         </div>
        );
}

export default AdminPage;

